import _taggedTemplateLiteral from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var _templateObject;
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Close } from '@mui/icons-material';
import Autocomplete from '@app/components/molecules/Autocomplete';
import TextField from '@app/components/atoms/TextField';
import IconButton from '@mui/material/IconButton';
import RoomIcon from '@mui/icons-material/Room';
import LanguageIcon from '@mui/icons-material/Language';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import PublicIcon from '@mui/icons-material/Public';
import DateRangeIcon from '@mui/icons-material/DateRange';
import Image from 'next/image';
import { gql, useMutation, useQuery } from '@apollo/client';
// import { CardActions, CardMedia } from '@material-ui/core';
// import Chip from '@material-ui/core/Chip';
import Skeleton from '@mui/lab/Skeleton';
import { ALL_OPPORTUNITIES, MY_SPACES, PREMIUM_USER_QUERY } from '@app/apollo/queries';
import { CREATE_SPACE, CLONE_OPPORTUNITY, DELETE_OPPORTUNITY } from '@app/apollo/mutations';
// import AccessAlarmRoundedIcon from '@material-ui/icons/AccessAlarmRounded';
import { CardActionArea, Tooltip, Box, Zoom, Dialog, DialogActions, DialogContent, DialogTitle
// CardMedia
} from '@mui/material';
import Button from '@atoms/Button';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Typography from '@atoms/Typography';
import Menu from '@molecules/Menu';
import Link from '@atoms/Link';
import { USER_ROLES } from '@app/config/constants';
import MutationsStatus from '@app/components/molecules/MutationsStatus';
import { OPP_STATUS_ENUM } from '@app/constants';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useUser } from '@app/helpers/hooks';
import { useTranslation } from '../../../../config/i18n';
import { redirectToRoute, isAdmin } from '../../../../helpers';
import { CardContent, ContentContainer, CardHeader, Card, CardLabel, useClasses, OrganisationAvatar, MetaItem, OpportunityDescription, StyledLink, CardSublabel } from './style';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var OpportunityCard = function OpportunityCard(_ref) {
  var _opp_role$permissions, _opp_role$permissions2, _opp_role$permissions3, _opp_role$permissions4, _oppsData$allOpportun, _userInfo$role;
  var id = _ref.id,
    slug = _ref.slug,
    title = _ref.title,
    location = _ref.location,
    is_draft = _ref.is_draft,
    opp_status = _ref.opp_status,
    logo = _ref.logo,
    deadline_date = _ref.deadline_date,
    organisation = _ref.organisation,
    start_date = _ref.start_date,
    is_virtual = _ref.is_virtual,
    is_worldwide = _ref.is_worldwide,
    end_date = _ref.end_date,
    description = _ref.description,
    is_paid = _ref.is_paid,
    space = _ref.space,
    summary = _ref.summary,
    types = _ref.types,
    user = _ref.user,
    userInfo = _ref.userInfo,
    onClick = _ref.onClick,
    refetch = _ref.refetch,
    oppSearch = _ref.oppSearch,
    loading = _ref.loading,
    opp_role = _ref.opp_role,
    reviewing = _ref.reviewing;
  var _useTranslation = useTranslation(['dashboard', 'applications', 'wizard', 'organisations']),
    t = _useTranslation.t;
  var formatTypes = function formatTypes(typeList, num) {
    var res = typeList.slice(0, num);
    var result = '';
    if (typeList.length > num) {
      result = "".concat(res.map(function (gen) {
        return " ".concat(gen.name);
      }), " ").concat(t('applications:common.and'), " ").concat(typeList.length - num, " ").concat(t('applications:common.others'));
    } else {
      result = "".concat(typeList.map(function (gen) {
        return " ".concat(gen.name);
      }));
    }
    return result;
  };
  var isDraft = is_draft || opp_status === OPP_STATUS_ENUM.DRAFT;
  var isClosed = opp_status === OPP_STATUS_ENUM.CLOSED || opp_status === OPP_STATUS_ENUM.ARCHIVED;
  var isScheduled = opp_status === OPP_STATUS_ENUM.SCHEDULED;
  var hasExpired = deadline_date && new Date(deadline_date) < new Date();
  var _useUser = useUser(),
    loggedUser = _useUser.user;
  var _useState = useState(null),
    anchorEl = _useState[0],
    setAnchorEl = _useState[1];
  var _useState2 = useState(false),
    deleteModal = _useState2[0],
    setDeleteModal = _useState2[1];
  var _useState3 = useState(false),
    isPremium = _useState3[0],
    setIsPremium = _useState3[1];
  var _useState4 = useState(false),
    oppDialog = _useState4[0],
    setOppDialog = _useState4[1];
  // const [selectedOpp, setSelectedOpp] = useState(null);

  var manageOpportunityRight = (opp_role === null || opp_role === void 0 ? void 0 : (_opp_role$permissions = opp_role.permissions) === null || _opp_role$permissions === void 0 ? void 0 : _opp_role$permissions.full_access) || (opp_role === null || opp_role === void 0 ? void 0 : (_opp_role$permissions2 = opp_role.permissions) === null || _opp_role$permissions2 === void 0 ? void 0 : _opp_role$permissions2.manage_opportunity) || (user === null || user === void 0 ? void 0 : user.id) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id);
  var viewPaymentRight = (opp_role === null || opp_role === void 0 ? void 0 : (_opp_role$permissions3 = opp_role.permissions) === null || _opp_role$permissions3 === void 0 ? void 0 : _opp_role$permissions3.full_access) || (opp_role === null || opp_role === void 0 ? void 0 : (_opp_role$permissions4 = opp_role.permissions) === null || _opp_role$permissions4 === void 0 ? void 0 : _opp_role$permissions4.manage_payments) || (user === null || user === void 0 ? void 0 : user.id) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id);
  var isAdminUser = loggedUser && isAdmin(loggedUser);
  var _useQuery = useQuery(ALL_OPPORTUNITIES),
    oppsData = _useQuery.data;
  var _useMutation = useMutation(CREATE_SPACE, {
      refetchQueries: function refetchQueries() {
        return [{
          query: MY_SPACES
        }];
      }
    }),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    createSpace = _useMutation2[0],
    _useMutation2$ = _useMutation2[1],
    createSpaceMutationLoading = _useMutation2$.loading,
    createSpaceMutationError = _useMutation2$.error,
    createSpaceMutationData = _useMutation2$.data;
  var _useQuery2 = useQuery(PREMIUM_USER_QUERY, {
      variables: {
        userId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id
      }
    }),
    premiumData = _useQuery2.data,
    premiumLoading = _useQuery2.loading;
  var toggleOppsDialog = function toggleOppsDialog() {
    setOppDialog(!oppDialog);
  };
  var handleDeleteDialogOpen = function handleDeleteDialogOpen() {
    setDeleteModal(true);
  };
  var handleDeleteDialogClose = function handleDeleteDialogClose() {
    setAnchorEl(null);
    setDeleteModal(false);
  };
  var _useMutation3 = useMutation(DELETE_OPPORTUNITY, {
      onCompleted: function onCompleted() {
        refetch();
        handleDeleteDialogClose();
      }
    }),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    deleteOpportunityMutation = _useMutation4[0],
    _useMutation4$ = _useMutation4[1],
    deleteMutationLoading = _useMutation4$.loading,
    deleteMutationError = _useMutation4$.error,
    deleteMutationData = _useMutation4$.data;
  var _useMutation5 = useMutation(CLONE_OPPORTUNITY, {
      onCompleted: function onCompleted() {
        refetch();
        setAnchorEl(null);
      }
    }),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    cloneOpportunity = _useMutation6[0],
    _useMutation6$ = _useMutation6[1],
    cloneOpportunityLoading = _useMutation6$.loading,
    cloneOpportunityError = _useMutation6$.error,
    cloneOpportunityData = _useMutation6$.data;
  var deleteOpportunityHandler = function deleteOpportunityHandler() {
    deleteOpportunityMutation({
      variables: {
        id: id
      }
    });
  };
  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var handleOpportunityManage = function handleOpportunityManage() {
    setAnchorEl(null);
    redirectToRoute({}, 'opportunity_dashboard', {
      params: {
        slug: slug
      }
    });
  };
  var handleAddApplicant = function handleAddApplicant() {
    setAnchorEl(null);
    redirectToRoute({}, 'form_viewer', {
      params: {
        slug: slug
      }
    });
  };
  var handleViewOpportunity = function handleViewOpportunity() {
    setAnchorEl(null);
    redirectToRoute({}, 'view_opportunity', {
      params: {
        slug: slug
      }
    });
  };
  var handleredirectOpportunity = function handleredirectOpportunity() {
    if (isAdminUser || manageOpportunityRight || reviewing) {
      onClick();
    } else {
      handleViewOpportunity();
    }
  };

  // const handleUpdateForm = () => {
  //   setAnchorEl(null);
  //   redirectToRoute({}, 'update_form', { params: { slug } });
  // };

  var handleUpdateOpportunity = function handleUpdateOpportunity() {
    setAnchorEl(null);
    redirectToRoute({}, 'update_opportunity', {
      params: {
        slug: slug
      }
    });
  };

  // const handleUpdatePaymentInfo = () => {
  //   setAnchorEl(null);
  //   redirectToRoute({}, 'opportunity_payment', { params: { slug } });
  // };

  var handleOpportunityPayments = function handleOpportunityPayments() {
    setAnchorEl(null);
    redirectToRoute({}, 'opportunity_payments_details', {
      params: {
        slug: slug
      }
    });
  };
  var handleCloneOpportunity = function handleCloneOpportunity() {
    cloneOpportunity({
      variables: {
        slug: slug
      }
    });
  };
  var handleDraftOpportunity = function handleDraftOpportunity() {
    setAnchorEl(null);
    redirectToRoute({}, 'draft_opportunity', {
      params: {
        slug: slug
      }
    });
  };

  // const handleOpportunitySelection = (event, value) => {
  //   setSelectedOpp(value);
  // };

  var opportunity = oppsData === null || oppsData === void 0 ? void 0 : (_oppsData$allOpportun = oppsData.allOpportunities) === null || _oppsData$allOpportun === void 0 ? void 0 : _oppsData$allOpportun.find(function (opp) {
    return opp.id === id;
  });
  var handleCreateSpace = function handleCreateSpace() {
    if (opportunity !== null && opportunity !== void 0 && opportunity.id) {
      createSpace({
        variables: {
          oppId: opportunity.id
        },
        onCompleted: function onCompleted() {
          toggleOppsDialog();
          redirectToRoute({}, 'spaces');
        }
      });
    }
  };
  var classes = useClasses();
  useEffect(function () {
    var _premiumData$premiumU;
    if (premiumData && !premiumLoading && (premiumData === null || premiumData === void 0 ? void 0 : (_premiumData$premiumU = premiumData.premiumUser) === null || _premiumData$premiumU === void 0 ? void 0 : _premiumData$premiumU.features[0]) === "spaces") {
      setIsPremium(true);
    }
  }, [premiumData, premiumLoading]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MutationsStatus, {
      loading: cloneOpportunityLoading || deleteMutationLoading || createSpaceMutationLoading,
      error: cloneOpportunityError || deleteMutationError || createSpaceMutationError,
      success: cloneOpportunityData || deleteMutationData || createSpaceMutationData
    }), /*#__PURE__*/_jsxs(Card, {
      variant: "elevation",
      children: [/*#__PURE__*/_jsx(CardActionArea, {
        children: loading ? /*#__PURE__*/_jsx(Skeleton, {
          animation: "wave",
          variant: "rect",
          height: 200
        }) : /*#__PURE__*/_jsxs("div", {
          "aria-hidden": "true",
          className: classes.mediaContainer,
          onClick: isDraft ? handleDraftOpportunity : handleredirectOpportunity,
          onKeyDown: isDraft ? handleDraftOpportunity : handleredirectOpportunity,
          children: [/*#__PURE__*/_jsx("div", {
            className: classes.image,
            children: /*#__PURE__*/_jsx(Image
            // className={classes.image}
            , {
              src: logo.path,
              alt: title
              // layout="intrinsic" height="250px" width="443px"
              ,
              onClick: isDraft ? handleDraftOpportunity : handleredirectOpportunity,
              layout: "fill",
              objectFit: "cover"
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "".concat(classes.additionalInfo, " additionalInfo"),
            children: [/*#__PURE__*/_jsx("div", {
              className: classes.details,
              children: /*#__PURE__*/_jsx(OpportunityDescription, {
                variant: "body1",
                children: summary || description
              })
            }), /*#__PURE__*/_jsx("div", {
              className: classes.stats,
              children: is_paid && /*#__PURE__*/_jsx(MonetizationOnOutlinedIcon, {})
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(CardContent, {
        children: loading ? /*#__PURE__*/_jsxs(Box, {
          width: "100%",
          pt: 0.5,
          children: [/*#__PURE__*/_jsx(Skeleton, {}), /*#__PURE__*/_jsx(Skeleton, {
            width: "60%"
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Link, {
            href: "organisation_view",
            params: {
              slug: organisation.slug
            },
            children: /*#__PURE__*/_jsx(OrganisationAvatar, {
              src: organisation.logo.thumb,
              elevation: 2,
              width: "64px"
            })
          }), /*#__PURE__*/_jsxs(ContentContainer, {
            children: [/*#__PURE__*/_jsx(Typography, {
              color: "primary",
              variant: "overline",
              children: /*#__PURE__*/_jsxs(StyledLink, {
                href: "organisation_view",
                params: {
                  slug: organisation.slug
                },
                onClick: function onClick(event) {
                  return event.stopPropagation();
                },
                children: [/*#__PURE__*/_jsxs(Typography, {
                  color: "primary",
                  variant: "overline",
                  children: [" ", organisation.name, " "]
                }), ' ']
              })
            }), /*#__PURE__*/_jsx(CardHeader, {
              action: (userInfo && user && user.id === userInfo.id || manageOpportunityRight || isAdminUser) && /*#__PURE__*/_jsxs(_Fragment, {
                children: [isDraft && /*#__PURE__*/_jsx(Typography, {
                  variant: "h6",
                  style: {
                    position: 'absolute',
                    bottom: 30,
                    right: 60
                  },
                  children: t('common:DRAFT')
                }), /*#__PURE__*/_jsx(IconButton, {
                  "aria-label": "settings",
                  "aria-controls": "simple-menu",
                  "aria-haspopup": "true",
                  onClick: handleClick,
                  children: /*#__PURE__*/_jsx(MoreVertIcon, {})
                })]
              })
              // title={<Link href="view_opportunity">{title}</Link>}
              ,
              title: title && title.length > 50 ? /*#__PURE__*/_jsx(Tooltip, {
                title: title,
                arrow: true,
                placement: "top",
                TransitionComponent: Zoom,
                TransitionProps: {
                  timeout: 300
                }
                // enterDelay={300}
                ,
                leaveDelay: 500,
                children: /*#__PURE__*/_jsx("div", {
                  children: /*#__PURE__*/_jsx(CardLabel, {
                    style: {
                      marginBottom: '10px'
                    },
                    variant: "h5",
                    onClick: isDraft ? handleDraftOpportunity : handleredirectOpportunity,
                    children: title
                  })
                })
              }) : /*#__PURE__*/_jsx(CardLabel, {
                style: {
                  marginBottom: '10px'
                },
                variant: "h5",
                onClick: isDraft ? handleDraftOpportunity : handleredirectOpportunity,
                children: title && title
              }),
              subheader: /*#__PURE__*/_jsxs(_Fragment, {
                children: [oppSearch && /*#__PURE__*/_jsxs(MetaItem, {
                  children: [isDraft ? /*#__PURE__*/_jsx(EditNoteIcon, {
                    fontSize: "small"
                  }) : hasExpired ? /*#__PURE__*/_jsx(HourglassTopIcon, {
                    fontSize: "small"
                  }) : isClosed ? /*#__PURE__*/_jsx(UnpublishedIcon, {
                    fontSize: "small"
                  }) : isScheduled ? /*#__PURE__*/_jsx(ScheduleSendIcon, {
                    fontSize: "small"
                  }) : /*#__PURE__*/_jsx(PublishedWithChangesIcon, {
                    fontSize: "small"
                  }), /*#__PURE__*/_jsx(Typography, {
                    variant: "caption",
                    children: isDraft ? t('common:DRAFT') : hasExpired ? t('common:COMPLETED') : isClosed ? t('common:CLOSED') : isScheduled ? t('common:SCHEDULED') : t('common:ACTIVE')
                  })]
                }), is_virtual || is_worldwide || location && location.formatted_address ? /*#__PURE__*/_jsx(Tooltip, {
                  title: is_worldwide ? t('common:worldwide_opportunity') : is_virtual ? t('common:virtual_opportunity') : location && location.formatted_address,
                  children: /*#__PURE__*/_jsxs(MetaItem, {
                    children: [is_worldwide ? /*#__PURE__*/_jsx(PublicIcon, {
                      fontSize: "small"
                    }) : is_virtual ? /*#__PURE__*/_jsx(LanguageIcon, {
                      fontSize: "small"
                    }) : /*#__PURE__*/_jsx(RoomIcon, {
                      fontSize: "small"
                    }), /*#__PURE__*/_jsx(CardSublabel, {
                      variant: "caption",
                      onClick: isDraft ? handleDraftOpportunity : handleredirectOpportunity,
                      children: is_worldwide ? t('common:worldwide_opportunity') : is_virtual ? t('common:virtual_opportunity') : location && "".concat(location.city, ", ").concat(location.country)
                    })]
                  })
                }) : /*#__PURE__*/_jsx(Tooltip, {
                  title: t('common:location'),
                  children: /*#__PURE__*/_jsxs(MetaItem, {
                    children: [/*#__PURE__*/_jsx(PublicIcon, {
                      fontSize: "small"
                    }), /*#__PURE__*/_jsx(Typography, {
                      variant: "caption",
                      children: t('common:No Selection')
                    })]
                  })
                }), start_date ? /*#__PURE__*/_jsx(Tooltip, {
                  title: t('common:Start Date and End Date'),
                  children: /*#__PURE__*/_jsxs(MetaItem, {
                    children: [/*#__PURE__*/_jsx(DateRangeIcon, {
                      fontSize: "small"
                    }), /*#__PURE__*/_jsx(Typography, {
                      variant: "caption",
                      children: "".concat(moment(start_date).format('DD MMM'), " ").concat(end_date ? "- ".concat(moment(end_date).format('D MMM  YYYY')) : '')
                    })]
                  })
                }) : /*#__PURE__*/_jsx(_Fragment, {}), types && types.length > 0 ? /*#__PURE__*/_jsx(Tooltip, {
                  title: t('common:Opportunity Categories'),
                  children: /*#__PURE__*/_jsxs(MetaItem, {
                    children: [/*#__PURE__*/_jsx(LibraryMusicIcon, {
                      fontSize: "small"
                    }), /*#__PURE__*/_jsx(Typography, {
                      variant: "caption",
                      children: formatTypes(types, 3)
                    })]
                  })
                }) : /*#__PURE__*/_jsx(Tooltip, {
                  title: t('common:Opportunity Categories'),
                  children: /*#__PURE__*/_jsxs(MetaItem, {
                    children: [/*#__PURE__*/_jsx(LibraryMusicIcon, {
                      fontSize: "small"
                    }), /*#__PURE__*/_jsx(Typography, {
                      variant: "caption",
                      children: t('common:No Selection')
                    })]
                  })
                }), deadline_date ? /*#__PURE__*/_jsx(Tooltip, {
                  title: t('common:Deadline Date'),
                  children: /*#__PURE__*/_jsxs(MetaItem, {
                    children: [/*#__PURE__*/_jsx(AccessAlarmIcon, {
                      fontSize: "small"
                    }), /*#__PURE__*/_jsx(Typography, {
                      variant: "caption",
                      children: moment(deadline_date).format('DD MMM YYYY')
                    })]
                  })
                }) : /*#__PURE__*/_jsx(Tooltip, {
                  title: t('common:Deadline Date'),
                  children: /*#__PURE__*/_jsxs(MetaItem, {
                    children: [/*#__PURE__*/_jsx(AccessAlarmIcon, {
                      fontSize: "small"
                    }), /*#__PURE__*/_jsx(Typography, {
                      variant: "caption",
                      children: t('common:Ongoing')
                    })]
                  })
                })]
              })
            })]
          })]
        })
      })]
    }), /*#__PURE__*/_jsxs(Menu, {
      id: "simple-menu",
      anchorEl: anchorEl,
      keepMounted: true,
      open: Boolean(anchorEl),
      onClose: handleClose,
      elevation: 0,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      children: [!isDraft && (manageOpportunityRight || isAdminUser) && /*#__PURE__*/_jsx(Menu.Item, {
        style: {
          textTransform: 'capitalize'
        },
        onClick: handleOpportunityManage,
        children: t('applications:manage_opp')
      }), !isDraft && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Menu.Item, {
          style: {
            textTransform: 'capitalize'
          },
          onClick: handleViewOpportunity,
          children: t('applications:view_opp')
        }), /*#__PURE__*/_jsx(Menu.Item, {
          style: {
            textTransform: 'capitalize'
          },
          onClick: handleUpdateOpportunity,
          children: t('applications:edit_opp_info')
        })]
      }), !isDraft && /*#__PURE__*/_jsx(Menu.Item, {
        style: {
          textTransform: 'capitalize'
        },
        onClick: handleAddApplicant,
        children: t('applications:add_applicant')
      }), !isDraft && viewPaymentRight && /*#__PURE__*/_jsx(Menu.Item, {
        style: {
          textTransform: 'capitalize'
        },
        onClick: handleOpportunityPayments,
        children: t('applications:view_paiments')
      }), !isDraft && /*#__PURE__*/_jsx(Menu.Item, {
        style: {
          textTransform: 'capitalize'
        },
        onClick: handleCloneOpportunity,
        children: t('applications:Duplicate Opportunity')
      }), isDraft && (manageOpportunityRight || isAdminUser) && /*#__PURE__*/_jsx(Menu.Item, {
        style: {
          textTransform: 'capitalize'
        },
        onClick: handleDeleteDialogOpen,
        children: t('common:delete')
      }), (manageOpportunityRight || isAdminUser) && isPremium && !space && !isDraft && (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$role = userInfo.role) === null || _userInfo$role === void 0 ? void 0 : _userInfo$role.name) !== USER_ROLES.USER && /*#__PURE__*/_jsx(Menu.Item, {
        style: {
          textTransform: 'capitalize'
        },
        onClick: toggleOppsDialog,
        children: t('common:Create Community')
      })]
    }), /*#__PURE__*/_jsxs(Dialog, {
      open: deleteModal,
      onClose: handleDeleteDialogClose,
      "aria-labelledby": "form-dialog-title",
      children: [/*#__PURE__*/_jsx(DialogTitle, {
        id: "form-dialog-title",
        children: "".concat(t('common:delete'), " ").concat(t('common:opportunity'))
      }), /*#__PURE__*/_jsx(DialogContent, {
        children: t('applications:delete_opportunity_message')
      }), /*#__PURE__*/_jsxs(DialogActions, {
        children: [/*#__PURE__*/_jsx(Button, {
          variant: "outlined",
          onClick: handleDeleteDialogClose,
          color: "primary",
          children: t('common:cancel')
        }), /*#__PURE__*/_jsx(Button, {
          onClick: deleteOpportunityHandler,
          color: "primary",
          children: t('common:delete')
        })]
      })]
    }), /*#__PURE__*/_jsxs(Dialog, {
      onClose: toggleOppsDialog,
      open: oppDialog,
      maxWidth: "sm",
      fullWidth: true,
      scroll: "paper",
      children: [/*#__PURE__*/_jsx(DialogTitle, {
        children: "Create Community Space"
      }), /*#__PURE__*/_jsx(IconButton, {
        "aria-label": "close",
        onClick: toggleOppsDialog,
        sx: {
          position: 'absolute',
          right: 8,
          top: 8,
          color: function color(theme) {
            return theme.palette.grey[500];
          }
        },
        children: /*#__PURE__*/_jsx(Close, {})
      }), /*#__PURE__*/_jsx(DialogContent, {
        children: /*#__PURE__*/_jsx(Autocomplete, {
          id: "opportunities-list",
          options: (oppsData === null || oppsData === void 0 ? void 0 : oppsData.allOpportunities) || [],
          getOptionLabel: function getOptionLabel(option) {
            return option && option.title ? option.title : '';
          },
          disabled: true
          // onChange={handleOpportunitySelection}
          ,
          defaultValue: opportunity || null,
          value: opportunity || null,
          limitTags: 5,
          filterSelectedOptions: true,
          renderOption: function renderOption(props, option) {
            var _option$logo, _option$logo2;
            return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
              component: "li",
              sx: {
                '& > img': {
                  mr: 2,
                  flexShrink: 0
                }
              }
            }, props), {}, {
              children: [/*#__PURE__*/_jsx("img", {
                loading: "lazy",
                width: "25",
                height: "25",
                srcSet: (_option$logo = option.logo) === null || _option$logo === void 0 ? void 0 : _option$logo.path,
                src: (_option$logo2 = option.logo) === null || _option$logo2 === void 0 ? void 0 : _option$logo2.path,
                alt: "option.title",
                style: {
                  borderRadius: '5px'
                }
              }), option.title]
            }));
          },
          renderInput: function renderInput(params) {
            return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, params), {}, {
              label: "Selected Opportunity",
              placeholder: "Opportunites"
            }));
          }
        })
      }), /*#__PURE__*/_jsx(DialogActions, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: createSpaceMutationLoading,
          onClick: handleCreateSpace,
          children: "Create"
        })
      })]
    })]
  });
};
OpportunityCard.defaultProps = {
  id: '',
  userInfo: undefined,
  loading: false,
  onClick: undefined,
  refetch: function refetch() {},
  title: undefined,
  is_virtual: false,
  is_worldwide: false,
  slug: '',
  location: undefined,
  logo: undefined,
  space: undefined,
  deadline_date: '',
  start_date: '',
  end_date: '',
  types: [],
  user: undefined,
  oppSearch: false,
  organisation: undefined,
  reviewing: false
};
OpportunityCard.fragments = {
  opportunity: gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fragment OpportunityCard on Opportunity {\n      id\n      title\n      slug\n      description\n      summary\n      location {\n        formatted_address\n        city\n        country\n      }\n      logo {\n        path\n      }\n      organisation {\n        name\n        slug\n        logo {\n          thumb\n        }\n      }\n      is_paid\n      space {\n        id\n      }\n      deadline_date\n      start_date\n      end_date\n      is_virtual\n      is_worldwide\n      payment_options\n      types {\n        id\n        name\n      }\n      user {\n        id\n        name\n        avatar {\n          path\n        }\n      }\n      opp_role {\n        role\n        permissions {\n          full_access\n          rate\n          comment\n          manage_opportunity\n          manage_applications\n          manage_payments\n        }\n      }\n    }\n  "])))
};
export default OpportunityCard;